// changePassword.js
import axiosInstance from 'services/axiosMiddleware';

export async function changePassword({ oldPassword, newPassword }) {
  try {
    const response = await axiosInstance.post('users/change-password', { oldPassword, newPassword });
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
